import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import OrderController, { KnockOrderLandingItemType } from '../controller/OrderController';
import { useToast } from '../controller/ToastController';
import { langText } from '../recoil/lang';

interface PropsType {
  orderData: KnockOrderLandingItemType;
  lang: number;
  refresh: any;
}

const RatingContent = ({ orderData, lang, refresh }: PropsType) => {
  const showToast = useToast();
  const [foodRating, setFoodRating] = useState<number>(5);
  const [deliveryRating, setDeliveryRating] = useState<number>(5);
  const [review, setReview] = useState<string>('');

  const sendReview = async () => {
    try {
      const oParams = {
        order_id: orderData.order_id,
        order_seq: orderData.order_seq,
        store_id: orderData.store_id,
        parent_store_id: orderData.parent_store_id,
        food_score: foodRating,
        delivery_score: deliveryRating,
        content: review,
      };
      const oRes: any = await OrderController.setReview(oParams);

      if (oRes && oRes.data) {
        if (oRes.data.success) {
          showToast(langText.review_registered[lang]);
          refresh();
        } 
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  return (
    <Style>
      <div className="RatingContentWrap">
        <h2>{langText.satisfaction_feedback[lang]}</h2>
        <div>
          <div className="ratingContent">
            <h3>{langText.food_satisfaction[lang]}</h3>
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star.svg`}
                alt="별점 아이콘"
                onClick={() => setDeliveryRating(1)}
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  deliveryRating < 2 ? '_inactive' : ''
                }.svg`}
                onClick={() => setDeliveryRating(2)}
                alt="별점 아이콘"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  deliveryRating < 3 ? '_inactive' : ''
                }.svg`}
                onClick={() => setDeliveryRating(3)}
                alt="별점 아이콘"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  deliveryRating < 4 ? '_inactive' : ''
                }.svg`}
                onClick={() => setDeliveryRating(4)}
                alt="별점 아이콘"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  deliveryRating < 5 ? '_inactive' : ''
                }.svg`}
                onClick={() => setDeliveryRating(5)}
                alt="별점 아이콘"
              />
            </div>
          </div>
          <div className="ratingContent">
            <h3>{langText.delivery_satisfaction[lang]}</h3>
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star.svg`}
                alt="별점 아이콘"
                onClick={() => setFoodRating(1)}
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  foodRating < 2 ? '_inactive' : ''
                }.svg`}
                onClick={() => setFoodRating(2)}
                alt="별점 아이콘"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  foodRating < 3 ? '_inactive' : ''
                }.svg`}
                onClick={() => setFoodRating(3)}
                alt="별점 아이콘"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  foodRating < 4 ? '_inactive' : ''
                }.svg`}
                onClick={() => setFoodRating(4)}
                alt="별점 아이콘"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_star${
                  foodRating < 5 ? '_inactive' : ''
                }.svg`}
                onClick={() => setFoodRating(5)}
                alt="별점 아이콘"
              />
            </div>
          </div>
          <textarea
            value={review}
            placeholder={langText.text_review[lang]}
            autoFocus={false}
            onChange={(e) => setReview(e.target.value)}
          />
        </div>
        <button onClick={sendReview} className="sendRating">
          <h3>{langText.leave_review_label[lang]}</h3>
        </button>
      </div>
    </Style>
  );
};

export default RatingContent;

export const Style = styled.div`
  .RatingContentWrap {
    width: 100%;
    padding: 30px 3vw;

    h2 {
      margin-bottom: 24px;
      font-size: 18px;
      font-weight: 600;
      color: #555;
      text-align: center;
    }
  }
  .ratingContent {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  textarea {
    width: 100%;
    margin-top: 30px;
    min-height: 90px;
    padding: 11px 14px;
    font-size: 14px;
    font-weight: 300;
    color: #919191;
    border-color: #e5e5e5;
    border-radius: 8px;
  }
  .sendRating {
    width: 100%;
    margin-top: 18px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #4dd2ae;
    color: #fff;
    border-radius: 50px;
    gap: 20px;

    h3 {
      color: #fff;
    }
  }
`;
